import request from '@/router/axios';

const pre_fix = '/dotadmin/dotadmin/qcflow/';

export function pageQcFlow(param) {
  return request({
    url: pre_fix + 'page/',
    method: 'get',
    params: param,
  });
}

export function qcOldTaskPage(param) {
  return request({
    url: pre_fix + 'qcOldTaskPage/',
    method: 'get',
    params: param,
  });
}

export function pageTask(param) {
  return request({
    url: pre_fix + 'task/page',
    method: 'get',
    params: param,
  });
}

export function queryQcTask(qcTaskId) {
  return request({
    url: pre_fix + 'queryQcTask/' + qcTaskId,
    method: 'get',
  });
}

export function updateQcTask(qcInfo) {
  return request({
    url: pre_fix + 'updateQcTask',
    method: 'post',
    data: qcInfo,
  });
}

/**
 * 已阅无误，单句
 * @param qcTaskId
 * @returns {*}
 */
export function readNoMistake(qcInfo) {
  return request({
    url: pre_fix + 'readNoMistake',
    method: 'post',
    params: qcInfo,
  });
}

export function qcUpdateText(qcInfo) {
  return request({
    url: pre_fix + 'qcUpdateText',
    method: 'post',
    data: qcInfo,
  });
}

export function lowCheck(obj) {
  return request({
    url: pre_fix + 'lowCheck',
    method: 'post',
    data: obj,
  });
}

export function returnQcTask(qcInfo) {
  return request({
    url: pre_fix + 'returnQcTask',
    method: 'post',
    params: qcInfo,
  });
}

export function returnAllQcTask(obj) {
  return request({
    url: pre_fix + 'returnAllQcTask',
    method: 'post',
    params: obj,
  });
}

export function passAllQcTask(obj) {
  return request({
    url: pre_fix + 'passAllQcTask',
    method: 'post',
    params: obj,
  });
}

export function receiveQc(qcInfo) {
  return request({
    url: pre_fix + 'receiveQc',
    method: 'post',
    params: qcInfo,
  });
}

export function finishQcFlow(flowId) {
  return request({
    url: pre_fix + 'finishQcFlow/' + flowId,
    method: 'post',
  });
}

export function taskNumByNofinish(data) {
  return request({
    url: pre_fix + 'taskNumByNofinish',
    method: 'get',
    params: data,
  });
}

export function sentAround(qcInfo) {
  return request({
    url: pre_fix + 'sentAround',
    method: 'get',
    params: qcInfo,
  });
}

export function peAuditDetail(qcInfo) {
  return request({
    url: pre_fix + 'peAuditDetail',
    method: 'get',
    params: qcInfo,
  });
}

/**
 * 根据句子ID查询句子所在包的所有句子
 * @param sentId
 * @returns {*}
 */
export function packageSentenceList(sentId, orderId) {
  return request({
    url: pre_fix + 'packageSentenceList/' + sentId + '/' + orderId,
    method: 'get',
  });
}

/**
 * 根据昵称查找译员
 * @param name
 * @returns {*}
 */
export function queryTrIdByName(name) {
  return request({
    url: pre_fix + 'queryTrIdByName',
    method: 'post',
    data: name,
  });
}

/**
 * 查看该译员已阅无误的统计
 * @param qcInfo
 * @returns {*}
 */
export function riskNumTj(qcInfo) {
  return request({
    url: pre_fix + 'riskNumTj',
    method: 'get',
    params: qcInfo,
  });
}

/**
 * 批量打回页面统计数据
 * @param qcInfo
 * @returns {*}
 */
export function returnQcTaskTj(qcInfo) {
  return request({
    url: pre_fix + 'returnQcTaskTj',
    method: 'get',
    params: qcInfo,
  });
}

export function trPeAuditCountByOrderId(obj) {
  return request({
    url: '/dotadmin/dotadmin/qc/' + 'trPeAuditCountByOrderId',
    method: 'get',
    params: obj,
  });
}

//黑名单列表
export function qcDisableTrPage(data) {
  return request({
    url: pre_fix + '/qcDisableTrPage',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

//拉黑
export function qcDisableTr(data) {
  return request({
    url: pre_fix + '/qcDisableTr',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

//拉黑操作日志
export function qcDisableLogPage(data) {
  return request({
    url: pre_fix + '/qcDisableLogPage',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

//白名单列表
export function dotWhiteListPage(data) {
  return request({
    url: pre_fix + '/dotWhiteListPage',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

//设置白名单
export function setDotWhiteList(data) {
  return request({
    url: pre_fix + '/setDotWhiteList',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 机翻直出错误分类
export function getQcUpdateReason(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/getQcUpdateReason',
    method: 'get',
    params: data,
  });
}

// ===========术语一致性检查=========== //
// 低错分页
export function getLowErrors(data) {
  return request({
    url: '/dotadmin/dotadmin/check/low/page',
    method: 'get',
    params: data,
  });
}

// 低错检查
export function uniformLowCheck(data) {
  return request({
    globalLoading: false,
    url: '/dotadmin/dotadmin/check/low/check',
    method: 'post',
    data: data,
  });
}

export function modifyLowErrors(data) {
  return request({
    url: '/dotadmin/dotadmin/check/low/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyLowErrors(data) {
  return request({
    url: '/dotadmin/dotadmin/check/low/submitBatch',
    method: 'post',
    data: data,
  });
}

// 术语缺失
export function getUnusedTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/check/unusedTerm/page',
    method: 'get',
    params: data,
  });
}

export function modifyUnusedTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/check/unused/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyUnusedTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/check/unused/submitBatch',
    method: 'post',
    data: data,
  });
}

// 高频词不一致
export function getMessyHighTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/check/highTerm/page',
    method: 'get',
    params: data,
  });
}

export function modifyHighTerm(data) {
  return request({
    url: '/dotadmin/dotadmin/check/highTerm/submit',
    method: 'post',
    data: data,
  });
}

// 高相似
export function getHighSimilar(data) {
  return request({
    url: '/dotadmin/dotadmin/check/highsimilar/page',
    method: 'get',
    params: data,
  });
}

export function modifyHighSimilar(data) {
  return request({
    url: '/dotadmin/dotadmin/check/highsimilar/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyHighSimilar(data) {
  return request({
    url: '/dotadmin/dotadmin/check/highsimilar/submitBatch',
    method: 'post',
    data: data,
  });
}

// 关键句子
export function getCritical(data) {
  return request({
    url: '/dotadmin/dotadmin/check/critical/page',
    method: 'get',
    params: data,
  });
}

export function modifyCritical(data) {
  return request({
    url: '/dotadmin/dotadmin/check/critical/submit',
    method: 'post',
    data: data,
  });
}

export function batchModifyCritical(data) {
  return request({
    url: '/dotadmin/dotadmin/check/critical/submitBatch',
    method: 'post',
    data: data,
  });
}

// 步骤控制：下一步
export function setUniformCheckStep(data) {
  return request({
    url: '/dotadmin/dotadmin/check/flow/next',
    method: 'post',
    params: data,
  });
}

// 步骤控制：获取检查流程
export function getUniformCheckStatus(data) {
  return request({
    url: '/dotadmin/dotadmin/check/flow/get',
    method: 'get',
    params: data,
  });
}

// 步骤控制：检查是否可下一步&获取错误数量
export function getUniformTaskStatus(data) {
  return request({
    url: '/dotadmin/dotadmin/check/flow/page',
    method: 'get',
    params: data,
  });
}

// 一致性检查：提交订单
export function submitUniformCheck(data) {
  return request({
    url: '/dotadmin/dotadmin/check/flow/submit',
    method: 'post',
    params: data,
  });
}

// 判断是否检测中
export function getSmartCheckStatusByQcTaskId(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/getSmartCheckStatusByQcTaskId',
    method: 'post',
    params: data,
  });
}

// 单句低错检查
export function sentErrCheck(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/sentErrCheck',
    globalLoading: false,
    method: 'post',
    data: data,
  });
}

// 获取质控稿件预览结果
export function previewResult(obj) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/previewResult',
    method: 'get',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: obj,
  });
}

// 质控发起稿件预览
export function startQcPreviewFile(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/startQcPreviewFile',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: data,
  });
}

// 获取例句
export function getSentExampleList(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/getSentExampleList',
    method: 'get',
    params: data,
  });
}

// GPT润色
export function gptCompletion(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/gptCompletion',
    method: 'post',
    data: data,
  });
}

// GPT翻译
export function gptTran(data) {
  return request({
    url: '/dotadmin/dotadmin/qc/gptTran',
    method: 'post',
    data: data,
  });
}

// 获取智能检测句子数
export function getQcCheckCount(data) {
  console.log(data);
  return request({
    url: '/dotadmin/dotadmin/check/qcCheckCount',
    method: 'get',
    params: data,
  });
}

// 获取copilot的当前关注de提示
export function getQcCheckTips(data) {
  return request({
    url: '/dotadmin/dotadmin/check/qcCheckTips',
    method: 'get',
    params: data,
  });
}

// 获取copilot的当前关注提示
export function closeQcCheckTips(data) {
  return request({
    url: '/dotadmin/dotadmin/check/closeQcCheckTips',
    method: 'post',
    data: data,
  });
}

// 获取copilot中错误筛选后的句子
export function getCheckedList(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/task/checkPage',
    method: 'get',
    params: data,
  });
}

// 批量修改低错
export function batchUpdateLowCheckError(data) {
  return request({
    url: '/dotadmin/dotadmin/check/batchUpdateLowCheckError',
    method: 'post',
    data: data,
  });
}

// MTQC项目项目字数进度
export function taskFinishDetail(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/taskFinishDetail',
    method: 'get',
    params: data,
  });
}

// 过程或提交提醒
export function getSpeedAndEditRemind(data) {
  return request({
    url: '/dotadmin/dotadmin/qcflow/getSpeedAndEditRemind',
    method: 'get',
    params: data,
  });
}
